import { render, staticRenderFns } from "./GoodsCategoryManagement.vue?vue&type=template&id=87b9c20e&scoped=true"
import script from "./GoodsCategoryManagement.vue?vue&type=script&lang=js"
export * from "./GoodsCategoryManagement.vue?vue&type=script&lang=js"
import style0 from "./GoodsCategoryManagement.vue?vue&type=style&index=0&id=87b9c20e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b9c20e",
  null
  
)

export default component.exports